import React from 'react'
import { Link } from '@inertiajs/react'
import { ArrowRight } from 'lucide-react'

interface GuideRelatedLinksProps {
  links: Array<{ slug: string; title: string }>
}

export default function GuideRelatedLinks({ links }: GuideRelatedLinksProps) {
  if (links.length === 0) return null

  return (
    <div className="rounded-xl border border-border/60 bg-white p-5 shadow-sm">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">Related Guides</h3>
      <div className="flex flex-wrap gap-2">
        {links.map((link) => (
          <Link
            key={link.slug}
            href={`/guides/${link.slug}`}
            className="inline-flex items-center gap-1.5 rounded-lg border border-border/60 bg-muted/30 px-3 py-1.5 text-xs font-medium text-foreground hover:border-primary/30 hover:text-primary transition-colors"
          >
            {link.title}
            <ArrowRight className="h-3 w-3" />
          </Link>
        ))}
      </div>
    </div>
  )
}
